import { MutationTree } from 'vuex';
import { EmailDetailItem, EmailGroupItem, StatisticState } from './types';

export const mutations: MutationTree<StatisticState> = {

  setEmailStatisticDetail: (state, data: EmailDetailItem[]) => {
    state.emailStatisticDetail = data;
  },
  pushEmailStatisticDetail: (state, data: EmailDetailItem[]) => {
    state.emailStatisticDetail = state.emailStatisticDetail.concat(data);
  },
  setEmailStatisticDetailFlag: (state, flag: string) => {
    state.emailStatisticDetailFlag = flag;
  },

  setEmailStatisticGroup: (state, data: EmailGroupItem[]) => {
    state.emailStatisticGroup = data;
  },
  setMessagesCount: (state, count: number) => {
    state.emailMessageCount = count;
  },

};